<template>
  <!-- Wind page -->
  <div data-page="wind" class="week-page divide-y">
    <template v-for="(d, index) in daily" :key="'wind-'+d.time">
      <div class="p-4 active:bg-hover transition-colors duration-200" @click="toggleDay(index)">
        <div class="flex items-baseline justify-between">
          <div class="dowHeader">{{ formatDow(d.time, timezone, t, dateFormat) }}</div>
        </div>
        <div class="mt-1">
          <div class="flex items-center">
            <template v-if="index === 0" v-for="i in isPastElementsToAdd" :key="'isPast-' + i">
              <div class="wind-point-display">
                <IconHistoryToggleOff class="fill-secondary size-7" />
              </div>
            </template>
            <template v-for="(item, idx) in d.windPoints" :key="idx">
              <div class="wind-point-display">
                <div class="flex items-center h-12">
                  <IconCircle v-if="calculateBeaufortForce(item.speed) === 0"
                              class="transition-all duration-300 w-4"
                              :color="getWindColor(item.speed)" />
                  <IconNorth v-else
                                  class="transition-all duration-300"
                                  :width="getWindIconSize(item.speed)" :height="getWindIconSize(item.speed)"
                                  :style="`transform: rotate(${item.bearing + 180}deg);`"
                                  :color="getWindColor(item.speed)" />
                </div>
                <transition
                    enter-active-class="transition-all duration-300 ease-in-out"
                    leave-active-class="transition-all duration-300 ease-in-out"
                    enter-from-class="grid-rows-[0fr] opacity-0"
                    enter-to-class="grid-rows-[1fr] opacity-100"
                    leave-from-class="grid-rows-[1fr] opacity-100"
                    leave-to-class="grid-rows-[0fr] opacity-0"
                >
                  <div v-if="expandedDayIndex === index" class="grid overflow-hidden">
                    <div class="min-h-0">
                      <div class="flex flex-col items-center mt-1" v-if="!item.isPast">
                        <div class="text-base">{{ formatSpeed(item.speed, settingsStore.windSpeedUnits) }}</div>
                        <div class="text-sm text-secondary">
                          {{ formatTime(item.time, timezone) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </template>

          </div>

        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { useSettingsStore } from '../stores/settings.js';
import { useI18n } from 'vue-i18n';
import {computed} from 'vue';
import {formatSpeed, formatTime, formatDow, calculateBeaufortForce} from '../utils/formatters.js';
import {windColors} from '../utils/colors.js';
import IconHistoryToggleOff from '~icons/material-symbols/history-toggle-off';
import IconNorth from '~icons/material-symbols/north';
import IconCircle from '~icons/material-symbols/circle';

const settingsStore = useSettingsStore();

const { t, d: dateFormat } = useI18n();

const props = defineProps({
  daily: Array,
  timezone: String,
  expandedDayIndex: Number,
  toggleDay: Function,
});

const isPastElementsToAdd = computed(() => {
  const todayWindPointsLength = props.daily[0].windPoints.length;
  const tomorrowWindPointsLength = props.daily[1].windPoints.length;
  return Math.max(0, tomorrowWindPointsLength - todayWindPointsLength);
});

function getWindColor(speed) {
  const beaufortForce = calculateBeaufortForce(speed);
  const colorIndex = Math.min(beaufortForce, windColors.length - 1); // Clamp to max index
  return windColors[colorIndex];
}

function getWindIconSize(speed) {
  const beaufortForce = calculateBeaufortForce(speed);
  // Scale from 24px (Beaufort 0) to 48px (Beaufort 12)
  // The range is 24px, so each Beaufort unit adds 2px.
  return 24 + (beaufortForce * 2);
}
</script>

<style scoped>
@reference "../assets/main.css";
.wind-point-display {
  @apply flex-1 flex flex-col items-center justify-start;
}
</style>